<template>
  <div class="page">
    <div class="headerNav">
      <div class="nav">
        <div class="nav_content">公告资讯</div>
      </div>
      <div class="nav-left" @click="goBack"><img src="../../assets/new/left_b.svg" alt="" /></div>
    </div>
    <div class="header" style="padding: 46px 0">
      <van-tabs @click="onClick" color="#2A70F2" title-active-color="#2A70F2" v-model="activeName" sticky>
        <van-tab title="通知公告" name="a">
          <div class="group_1">
            <div class="box_1" @click="gotoDetail(item.id, 2)" v-for="item in noticeList" :key="item.id">
              <div class="box_left">
                <div class="text_1">{{ item.title || '' }}</div>
                <div class="text_2">发布时间：{{ item.publishTime ? item.publishTime.split(' ')[0] : '' }}</div>
              </div>
              <div class="box_right"><img src="../../assets/new/right (2).png" alt="" /></div>
            </div>
            <van-empty description="暂无公告" v-if="noticeList.length == 0" />
            <div @click="loadMore" v-if="hasMore" class="load-more">点击加载更多</div>
            <div v-else class="no-more">没有更多数据了~</div>
          </div>
        </van-tab>
        <van-tab title="行业资讯" name="b">
          <div class="group_1">
            <div class="box_1" @click="gotoDetail(item.id, 3)" v-for="item in noticeList" :key="item.id">
              <div class="box_left">
                <div class="text_1">{{ item.title || '' }}</div>
                <div class="text_2">发布时间：{{ item.publishTime ? item.publishTime.split(' ')[0] : '' }}</div>
              </div>
              <div class="box_right"><img src="../../assets/new/right (2).png" alt="" /></div>
            </div>
            <van-empty description="暂无咨讯" v-if="noticeList.length == 0" />
            <div @click="loadMore" v-if="hasMore" class="load-more">点击加载更多</div>
            <div v-else class="no-more">没有更多数据了~</div>
          </div>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import { toInfoMessage } from '../../api/index';

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      codeNo: '150104',
      noticeList: [],
      announcementList: [],
      total: '',
      pageSize: 10,
      pageNum: 1,
      hasMore: true,
      activeName: 'a'
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    //切换tab
    onClick(name, title) {
      this.pageNum = 1;
      if (name == 'a') {
        this.codeNo = '150104';
        this.getNoticelist(this.codeNo);
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      } else if (name == 'b') {
        this.codeNo = '150101';
        this.getNoticelist(this.codeNo);
        this.$nextTick(() => {
          const scrollContainer = document.querySelector('.page');
          if (scrollContainer) {
            scrollContainer.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
          }
        });
      }
    },
    //去详情
    gotoDetail(id, index) {
      this.$router.push({
        path: '/noticeDetail',
        query: {
          id: id,
          index: index
        }
      });
    },
    loadMore() {
      this.pageNum++;
      this.getNoticelist(this.codeNo);
    },
    //
    goBack() {
      this.$router.push({
        path: '/'
      });
    },
    //获取公告列表
    getNoticelist(codeNo) {
      const data = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        codeNo: codeNo
      };
      toInfoMessage(data).then(res => {
        if (this.pageNum == 1) {
          this.noticeList = res.data.rows;
             window.scrollTo({
          top: 0,
        });
        } else {
          this.noticeList = [...this.noticeList, ...res.data.rows];
        }
        this.total = res.data.total;
        this.hasMore = this.noticeList.length < this.total;
      });
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    if (this.$route.query.item) {
      this.activeName = this.$route.query.item;
      if (this.activeName == 'a') {
        this.onClick('a');
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      } else {
        this.onClick('b');
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    } else {
      this.activeName = 'a';
      this.onClick('a');
    }
    // this.getNoticelist(this.codeNo);
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.page {
  background-color: #f6f8fa;
  height: 100vh;
  overflow-y: scroll;
}
.group_1 {
  padding: 10px 15px;
  overflow-y: scroll;
  padding-bottom: 100px;
}
.load-more,
.no-more {
  text-align: center;
  padding: 10px;
  font-size: 14px;
  color: #999;
}
.no-more {
  color: #666;
}
.box_1 {
  // width: 345px;
  margin-bottom: 10px;
  height: 87px;
  background: #ffffff;
  border-radius: 8px 8px 8px 8px;
  padding: 20px 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .box_left {
    .text_1 {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 15px;
      color: #333333;
      width: 250px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .text_2 {
      margin-top: 8px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 13px;
      color: #999999;
    }
  }
  .box_right {
    width: 16px;
    height: 16px;
    img {
      width: 16px;
      height: 16px;
    }
  }
}
.headerNav {
  position: fixed;
  top: 0;
  width: 100%;
  height: 46px;
  background: #fff;
  border-radius: 0px 0px 0px 0px;
  z-index: 99;
}
.nav {
  padding: 0 15px;
  height: 46px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.nav-left {
  position: absolute;
  top: 15px;
  left: 15px;
}
.nav_content {
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  font-size: 17px;
  color: #333;
}
::v-deep {
  .van-tabs__line {
    width: 24px;
    height: 2px;
    border-radius: 2px 2px 2px 2px;
    margin-bottom: -7px;
    // margin-top: 10px;
  }
  .van-tabs__nav {
    position: fixed;
    top: 46px;
    left: 0;
    right: 0;
    width: 100%;
    height: 46px;
    padding-top: 0px;
    padding-bottom: 0px;
    overflow-y: scroll;
  }
  .van-tab--active {
    // margin-top: 10px;
  }
  .van-tabs__content {
    // margin: 56px 0;
    // padding: 0 15px;
    // padding:56px 15px;
    height: 100vh;
    // overflow-y: scroll;
  }
}
</style>
